import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_AUTHOR } from "../../actions/Detail/constants";
import { getSingleAuthor } from "../../utils/dataTransform/ContentItem/content";
import { app_reset } from "../App/reducer";

export const initAuthorState = () => {
    return {
        profile: {
            ...DEFAULT_AUTHOR,
        },
        recentContent: {},
    };
};

const authorSlice = createSlice({
    name: "author",
    initialState: initAuthorState(),
    reducers: {
        set_profile: {
            reducer: (state, action) => {
                return {
                    ...state,
                    profile: {
                        ...action.payload,
                    },
                };
            },
            prepare: (json) => {
                return {
                    payload: getSingleAuthor(json),
                };
            },
        },

        set_recent_content: (state, action) => {
            return {
                ...state,
                recentContent: {
                    list: action.payload.list,
                    pageValue: action.payload.pageValue,
                    hasNextPage: action.payload.hasNextPage,
                },
            };
        },

        reset: () => {
            return initAuthorState();
        },
    },
    extraReducers: (builder) => {
        builder.addCase(app_reset, () => {
            return initAuthorState();
        });
    },
});

export const {
    set_profile: set_author_profile,
    set_recent_content: set_author_recent_content,
    reset: reset_author,
} = authorSlice.actions;

export default authorSlice.reducer;
